import React, { useState, useEffect, useContext } from 'react';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import AlertContext from '../../../../../Context/Alert/AlertContext';
import { BaseURL } from '../../../../../Files/BaseURL';
import ThemeContext from '../../../../../Context/theme/ThemeContext';

const ServiceCategory = () => {
    const{theme}=useContext(ThemeContext);
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [services, setServices] = useState([]);
    const [serviceSkills, setServiceSkills] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const alertcontext = useContext(AlertContext);
    const { showAlert } = alertcontext;

    const fetchServices = async () => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/marektplace/Service/servicecategoryname`, {
                headers: {
                    'auth-token': authToken,
                }
            });
            const data = await response.json();
            setServices(data);
            setSelectedCategory(data[0]?._id);
        } catch (error) {
            showAlert('Error fetching Services', 'danger');
        }
    };

    const fetchServiceSkills = async (category) => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/marektplace/Service/servicecategoryDetail/${category}`, {
                headers: {
                    'auth-token': authToken,
                }
            });
            const data = await response.json();
            setServiceSkills(data);
        } catch (error) {
            showAlert('Error fetching Service Skills', 'danger');
        }
    };

    useEffect(() => {
        fetchServices();
    }, []);

    useEffect(() => {
        if (selectedCategory) {
            fetchServiceSkills(selectedCategory);
        }
    }, [selectedCategory]);

    // Filter services and subcategories based on the search query
    const filteredServiceSkills = serviceSkills?.Skills?.map(service => ({
        ...service,
        subSkill: service.subSkill.filter(sub => sub.name.toLowerCase().includes(searchQuery.toLowerCase()))
    })).filter(service => 
        service.skill.toLowerCase().includes(searchQuery.toLowerCase()) || 
        service.subSkill.length > 0
    );

    return (
        <div className='w-[95%] m-auto py-6'>
            <div className="flex flex-col gap-4 lg:flex-row justify-between font-pop lg:items-center">
                <div className="flex gap-2 md:gap-6 items-center">
                    <h3 className={`text-lg md:text-2xl font-medium   ${
                     theme == "dark" && "text-white"
                   }`}>Services</h3>
                </div>
                <div className={`flex gap-3 items-center  rounded-full py-1 px-4  ${
                     theme == "dark" ? "bg-black text-white" : "bg-gray-300 "
                   } 

`
                }>
                    <FaSearch className={`  text-gray-400 text-lg md:text-2xl    ${
                     theme == "dark" && "text-white"
                   }`   } />
                    <input
                        type="text"
                        placeholder='Search...'
                        className='bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none'
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
            </div>
            <div className="py-4 flex flex-wrap items-center gap-2">
                {services?.map((item, index) => (
                    <div
                        className={`cursor-pointer rounded-2xl py-1 px-2 border-2 font-pop ${item._id === selectedCategory && "border-primarygreen bg-primarygreen/20"}  ${
                     theme == "dark" ? "bg-black text-white" : "bg-white border-white "
                   } 

`}
                        key={index}
                        onClick={() => setSelectedCategory(item._id)}
                    >
                        {item.name}
                    </div>
                ))}
            </div>
            <div className="py-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-4 gap-x-4">
                {filteredServiceSkills?.map((service, index) => (
                    <div className={`font-pop h-fit rounded-2xl py-4 px-6 flex flex-col gap-4
                     ${
                     theme == "dark" ? "bg-black text-white" : "bg-white "
                   } 

`} key={index}>
                        <h2 className='text-xl font-medium'>{service.skill}</h2>
                        <div className="flex flex-col gap-2">
                            {service?.subSkill?.map((subItem, subIndex) => (
                                <p
                                    key={subIndex}
                                    className='cursor-pointer'
                                    onClick={() => { navigate(`/user-dashboard/service/servicelist/${subItem._id}`) }}
                                >
                                    {subItem.name}
                                </p>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ServiceCategory;
